import { FileToUpload } from './filetoupload';
import { OnboardVrifications } from './OnboardVrifications';

export class OnboardHREmpDetail {
  OnboardHRDetailsId: number;
  NamePerRecords: string;
  DOB: Date;
  CelebratedDOB: Date;
  Gender: string;
  TemporaryAddress: string;
  PermanentAddress: string;
  Mobile: string;
  PAN: string;
  Aadhar: string;
  BloodGroup: string;
  LocationID: number;
  RoleID: number;
  CadreId: number;
  DepartmentId: number;
  OptedNationalPensionScheme: boolean;
  NoOfDependents: number;
  FatherName: string;
  FatherAge: number;
  MotherName: string;
  MotherAge: number;
  MaritalStatus: number;
  WeddingDate: Date;
  SpouseName: string;
  SpouseCelebratedDOB: Date;
  Kids: string;
  PassportIssuePlace: string;
  PassportIssueDate: Date;
  PassportNumber: string;
  PassportExpiryDate: Date;
  UAN: string;
  NpsPran: string;
  BankAccount: string;
  BankName: string;
  BankAccountName: string;
  IFSCCode: string;
  Branch: string;
  slug: string;
  status: number;
  files: FileToUpload;
  AadharFilePath: string;
  AadharFileName: string;
  PanFilePath: string;
  PanFileName: string;
  Aadharfile: FileToUpload;
  Panfile: FileToUpload;
  Passportfile: FileToUpload;
  PassportFilePath: string;
  PassportFileName: string;
  onboardVrifications: OnboardVrifications = new OnboardVrifications();
 
}
